/**
 * api-人员管理
 */
import { post } from '@/utils/http'

// 获取服务人员的列表
export const apiGetServiceList = p => post('/BServer/getServiceList.do', p)
// 添加服务人员及教练
export const apiAddUser = p => post('/BUser/addBUser.do', p)
// 删除服务人员
export const apiDelServer = p => post('/BServer/delServer.do', p)
// 编辑服务人员
export const apiEditServer = p => post('/BServer/editServer.do', p)
// 获取服务人员的报表
export const apiGetDaily = p => post('/BServer/getDaily.do', p)
// 将服务人员改成普通用户
export const apiChangeServerToUsers = p =>
  post('/BServer/changeServerToUsers.do', p)
// 修改人员信息
export const apiEditUserInfo = p => post('/user/editUserInfo.do', p)
// 登记服务人员列表
export const apiGetServerInsertList = p =>
  post('/BServer/getServerInsertList.do', p)
// 审核已登记的服务人员
export const apiIsRead = p => post('/BServer/isRead.do', p)
// 商务合作申请列表
export const apiAgencyList = p => post('/BServer/agencyList.do', p)
// 确认商务合作
export const apiAgencyRead = p => post('/BServer/agencysRead.do', p)
